import { ObjectModel, ArrayModel, Any } from "objectmodel";

const BoxModel = new ObjectModel({
	size: new ObjectModel({ name: String, value: Number }),
	price: Number,
});

const CartItemImage = new ObjectModel({
	id: [String],
	src: [String],
	altText: [String],
});

const Discount = new ObjectModel({
	title: [String],
	amount: [Number]
});

const SellingPlanModel = new ObjectModel({
	id: String,
	name: String,
});

export const CartItemModel = new ObjectModel({
	id: String,
	tempId: String,
	title: String,
	handle: String,
	quantity: Number,
	type: [String],
	image: [CartItemImage],
	oneTime: Boolean,
	discounts: new ArrayModel(Discount),
	sellingPlan: [SellingPlanModel],
	variant: new ObjectModel({
		available: Boolean,
		sellingPlanAllocations: [
			new ArrayModel(
				new ObjectModel({ sellingPlan: SellingPlanModel })
			)
		],
		id: String,
		sku: String,
		title: String,
		price: Number,
		compareAtPrice: [Number],
		weight: Number,
		totalPrice: Number,
		discountedPrice: [Number],
		totalDiscountedPrice: [Number],
	}),
});


export const CartModel = new ObjectModel({
	id: String,
	attributes: [new ArrayModel(new ObjectModel({ key: String, value: String }))],
	items: Any,
	createdAt: Date,
	checkoutUrl: String,
	totalPrice: Number,
	totalQuantity: Number,
	delivery: [new ObjectModel({
		id: String,
		name: String,
		billingPolicy: new ObjectModel({
			intervalCount: Number,
			interval: String,
		}),
		_key: String,
		value: String
	})],
	mealsPerWeek: [Number],
	totalProgress: [Number],
	loading: Boolean,
	removeCount: [Number],
	discountCodes: [new ArrayModel([String])],
	isOpen: [Boolean],
	allGiftCards: [Boolean],
	activeBox: [BoxModel],
	bundlesAdded: [Boolean],
});
